import type { AcademyBadge, TrainingCourseDetail } from '~/types/academy/baseTraining';
import type { DoceboCatalogContentItem } from '~/types/docebo/catalog-content';
import { mapToAcademyImage } from '~/utils/academy/mapToAcademyImage';
import { mapDoceboSecondsToDurationMinutes } from '~/utils/academy/trainings/mapDoceboCourseFields';
import { trainingTypeBadge } from '~/utils/academy/trainings/doceboTrainingBadges';

export const DEFAULT_FALLBACK_IMAGE = '/assets/images/academy-background.svg';

function catalogItemImage(item: DoceboCatalogContentItem, fallbackImage: string) {
    return mapToAcademyImage({
        src: item.item_thumbnail,
        alt: item.item_name,
        fallbackSrc: fallbackImage
    });
}

export function buildCatalogContentItemUrl(
    item: Pick<DoceboCatalogContentItem, 'item_id' | 'item_slug'>,
    domain: string
): string {
    return `https://${domain}/learn/course/${item.item_id}/${item.item_slug}`;
}

export interface MapCatalogContentItemToTeaserItemOptions {
    item: DoceboCatalogContentItem;
    courseUrl: string;
    fallbackImage?: string;
}

export function mapCatalogContentItemToTeaserItem({
    item,
    courseUrl,
    fallbackImage = DEFAULT_FALLBACK_IMAGE
}: MapCatalogContentItemToTeaserItemOptions): TrainingCourseDetail {
    const badges: AcademyBadge[] = [];
    const typeBadge = trainingTypeBadge(item.course_type);

    if (typeBadge) {
        badges.push(typeBadge);
    }

    return {
        type: 'course',
        id: item.item_id,
        courseId: Number(item.item_id),
        title: item.item_name,
        shortDescription: '',
        description: item.item_description,
        image: catalogItemImage(item, fallbackImage),
        badges,
        createdAt: item.item_create_date,
        durationMinutes: mapDoceboSecondsToDurationMinutes(item.duration),
        points: null,
        status: null,
        certificateUrl: null,
        playUrl: courseUrl
    };
}
